/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Reducedfftemperature3Inputs */



/**
* | output |
* | --- |
* | "Reduced frost-free temperature" |
*
* @param {Ahu_History_Key_Reducedfftemperature3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_reducedfftemperature3 = /** @type {((inputs?: Ahu_History_Key_Reducedfftemperature3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Reducedfftemperature3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reduced frost-free temperature")
	return /** @type {LocalizedString} */ ("Température réduite hors gel")
});
export { ahu_history_key_reducedfftemperature3 as "ahu_history_key_reducedFFTemperature" }